var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"settings-wrapper"},[_c('button',{staticClass:"contrast",class:{'active': !_vm.settings.defaultContrast},attrs:{"aria-label":_vm.$t('header.availabilityAdjust.changeContrast')},on:{"click":_vm.changeContrast}})])
}
var staticRenderFns = []

export { render, staticRenderFns }